import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class IntangibleService {

 // URL: any = 'https://localhost:44306/api/Intangiblefixedassets/';
  URL = this.ConfigService.getAPIBaseUrl() + 'api/Intangiblefixedassets/';
  constructor(public HttpClient: HttpClient, private ConfigService: ConfigurationService) { }
  

  SaveIntangible(data) {
    debugger;
    return this.HttpClient.post(this.URL + "Adding", data)
  }
  
  GetOneIntangible(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URL + "GetOne?APPeriodId=" + APPeriodId)
  }
  GetOneIntangible_LY(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URL + "GetOne_LY?APPeriodId=" + APPeriodId)
  }
   
}
